module.exports = __webpack_public_path__ + "img/client8.5a7c4242.png";